import React, { useMemo } from "react";
import { EmptyStateErro } from "../../components/EmptyState";
import PainelTabela from "../../components/PainelTabela";
import { PageLoader } from "../../components/LoadingMarcenaria";
import { useDados } from "../../context/DadosContext";
import { F } from "../../utils/gerencialFields";
import { buildDeadlineStatus, compareDatesAsc } from "../../utils/status";

const COLUNAS = [
  { key: "cliente", label: "Cliente", noWrap: true },
  { key: "ambiente", label: "Ambiente" },
  { key: "numeroLote", label: "Nº Lote", labelCurto: "lote", width: "80px" },
  { key: "entregaContrato", label: "Entrega Prevista", labelCurto: "entrega", tipo: "data", width: "100px" },
  { key: "dataOtimizacao", label: "Data Otimização", labelCurto: "otimização", tipo: "data", width: "100px" },
  { key: "valor", label: "Valor", labelCurto: "valor", tipo: "moeda", width: "100px" },
  { key: "status", label: "Status", width: "100px" },
];

export default function SeparacaoFerragens() {
  const { dados, erro, initialLoading } = useDados();

  // Memoizado (e antes dos early-returns — Rules of Hooks): sem isso, cada
  // re-render recriava `linhas` (filter+map+sort de 400+ itens) e a nova
  // referência invalidava toda a cadeia de memos do PainelTabela.
  const linhas = useMemo(
    () =>
      dados
        .filter((row) => {
          const temOtimizacao = Boolean(row[F.OTIMIZACAO_DO_LOTE]);
          const temLote = Boolean(row[F.NUMERO_DO_LOTE]);
          const semFerragens = !row[F.INSUMOS_FERRAGENS];

          return temOtimizacao && temLote && semFerragens;
        })
        .map((row) => {
          const entregaContrato = row[F.ENTREGA_PREVISTA];

          return {
            cliente: row[F.NOME_DO_CLIENTE],
            rowPlanilha: row,
            ambiente: row[F.AMBIENTE],
            numeroLote: row[F.NUMERO_DO_LOTE],
            entregaContrato,
            dataOtimizacao: row[F.OTIMIZACAO_DO_LOTE],
            valor: row[F.VALOR_DO_AMBIENTE],
            ...buildDeadlineStatus(entregaContrato),
          };
        })
        .sort((left, right) => compareDatesAsc(left.entregaContrato, right.entregaContrato)),
    [dados],
  );

  const totalizadores = useMemo(
    () => [
      { label: "Total de Ambientes", valor: linhas.length },
      {
        label: "Em Atraso",
        valor: linhas.filter((linha) => linha.statusVariant === "danger").length,
      },
    ],
    [linhas],
  );

  if (initialLoading) {
    return <PageLoader scope="ferragens" />;
  }

  if (erro) {
    return <EmptyStateErro erro={erro} />;
  }

  return (
    <PainelTabela
      titulo="Separação de Ferragens"
      exportPainelId="ferragens"
      colunas={COLUNAS}
      linhas={linhas}
      totalizadores={totalizadores}
      densidade="compact"
      mostrarPaginacao={false}
      persistirNoBackend
    />
  );
}
